if (!customElements.get('collections-list')) {
    class CollectionsList extends HTMLElement {
        constructor() {
            super();

            this.elNavigation = this.querySelector('[data-collection-navigation]');
            this.elCollections = this.querySelectorAll('[data-collection]');
            this.elCollectionLinks = this.querySelectorAll('[data-collection-navigation-link]');

            this.appendCollectionLinks();
        }

        appendCollectionLinks() {
            const html = [...this.elCollections].map(el => `
                <li class="collections-list--navigation-link link">
                    <a href="#${el.dataset.collection}" data-collection-navigation-link>
                        ${el.dataset.title}
                    </a>
                </li>
            `).join('');

            this.elNavigation.innerHTML = html;
            this.elCollectionLinks = this.querySelectorAll('[data-collection-navigation-link]');
            this.elCollectionLinks.forEach(el => el.addEventListener('click', this.jumpToCollection.bind(this)));
        }

        jumpToCollection(ev) {
            ev.preventDefault();
            const sectionId = ev.currentTarget.href.split('#')[1];
            const elSection = document.getElementById(sectionId);
            if (!elSection) return;

            const headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const headerHeight = parseFloat(headerHeightValue) * rootFontSize;

            let top = elSection.offsetTop - headerHeight;

            window.scrollTo({
                top: top,
                behavior: 'smooth'
            });
        }
    }
    customElements.define('collections-list', CollectionsList);
}